<template>
  <p>
    El perfilador de tamaño de aerosoles (ambient particulate profiler) es un
    instrumento que realiza mediciones continúas de la distribución del tamaño
    de aerosoles. Utiliza tecnología de dispersión de una fuente de luz láser
    para detectar, dimensionar y contar partículas. Esta información se emite en
    8 rangos de tamaño: de 0.3 a 10 μm. Registra desde 0 a 9’000,000 de
    partículas por metro cúbico, con un flujo de 1 LPM.
  </p>
  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/aerosoles.webp"
    alt="Perfilador de aerosoles"
  />
  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>
      Concentración de partículas en 8 rangos de tamaño (partículas por litro)
    </li>
  </List>

  <p>
    <b>Marca y modelo: </b> <br />
    Met One, 212
  </p>
  <p>
    <b>País: </b> <br />
    EE.UU.
  </p>
  <p>
    <b>Especificaciones técnicas: </b> <br />
    <a
      href="https://metone.com/products/model-212-ambient-particulate-profiler/"
      target="_blank"
      >https://metone.com/products/model-212-ambient-particulate-profiler/</a
    >
  </p>
  <p>
    <b>Responsable: </b> <br />
    lsuarez@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  // Obtener el nombre de la ruta

  name: "FotometroSolar",
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
  components: { List },
};
</script>
